import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { IFreight, TCountry } from '~/src/repositories/FreightRepository/models/Freight'

interface IErrors {
  [key: string]: {
    message: string
  }
}

export function useForm(defaultValues: IFreight) {
  const [formValue, setFormValue] = useState<IFreight>(defaultValues)
  const [errors, setErrors] = useState<IErrors>()
  const { t } = useTranslation('yup_error')

  const schema = yup.object().shape({
    arrival: yup.object().required(t('this_field_is_required_item.')),
    departure: yup.object().required(t('this_field_is_required_item.')),
    estimate20ft: yup.number().required(t('this_field_is_required_item.')),
    estimate40ft: yup.number().required(t('this_field_is_required_item.')),
    estimatedAt: yup.string().required(t('this_field_is_required_item.')),
    id: yup.number().required(t('this_field_is_required_item.')),
  })

  function validation(): boolean {
    setErrors(undefined)
    try {
      schema.validateSync(formValue, { abortEarly: false })
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        if (error.inner) {
          const newErrors: IErrors = {}
          error.inner.forEach((err) => {
            if (err.path && err.message) {
              newErrors[err.path] = { message: err.message }
            }
          })
          setErrors(newErrors)
          return false
        }
      }
    }

    return true
  }

  return {
    formValue,
    setFormValue,
    validation,
    errors,
    setErrors,
  }
}
